// src/pages/Login.jsx
import "../assets/stylesheets/login.css";

import SpotifyIcon from '../assets/spotify.svg'
import GoogleIcon from '../assets/google.svg'

export default function Login() {
    return (
        <div className="container">
            {/*<div className="left-section"></div>*/}
            <div className="right-section">
                <div className="login-card">
                    <h1>Ready to Listen?</h1>
                    <button className="create-account-btn">Create an Account</button>
                    <div className="divider">
                        <span>Or Sign In</span>
                    </div>
                    <div className="social-login">
                        <a
                            href="api/login"
                            style={{ textDecoration: "none" }}>
                            <button
                                className="social-btn spotify-btn"
                                title="Sign in with Spotify"
                            >
                                <img className="social-icon spotify-icon" alt="Spotify icon" src={SpotifyIcon}></img>
                            </button>
                        </a>
                        <button className="social-btn google-btn" title="Sign in with Google">
                            <img className="social-icon google-icon" alt="Google icon" src={GoogleIcon}></img>
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
}
